// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__308uZ","label":"styles_label__3vdZQ"};